// extracted by mini-css-extract-plugin
module.exports = {"BackToTop":"BackToTop_BackToTop__3Z_ua","linkTop":"BackToTop_linkTop__2CGYG"};